import actionsTypes from "../constants/ActionTypes";

const initialState = {
    menuOpen: false
}

export const MenuOpenReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case actionsTypes.CLICK_OPEN_MENU:
            return {
                ...state,
                menuOpen: !state.menuOpen
                }; 
        default:
            return state;
    }
};